import { render, staticRenderFns } from "./MemoryComment.vue?vue&type=template&id=7fc2a2e4&scoped=true"
import script from "./MemoryComment.vue?vue&type=script&lang=js"
export * from "./MemoryComment.vue?vue&type=script&lang=js"
import style0 from "./MemoryComment.vue?vue&type=style&index=0&id=7fc2a2e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc2a2e4",
  null
  
)

export default component.exports